import {userAddToCart} from '../inc/gtag';

export const pickSubscription = () => {
  const subscriptions = document.querySelectorAll('.fitXr__pickSub__item ');
  const subscriptionsBtns = document.querySelectorAll('.fitxr-pickSub-item');
  const openCheckoutBtn = document.querySelectorAll('.open-checkout');

  if (!subscriptions.length) return;

  subscriptions.forEach((subscription) => {
    subscription.addEventListener('click', (e) => {
      e.preventDefault();

      subscriptionsBtns.forEach((subscription) => {
        subscription.classList.add('no_display');
      });

      subscriptions.forEach((subscription) => {
        subscription.classList.remove('active');
      });

      document.querySelectorAll('.fitxr-subscription__item-mobile').forEach((itemDescription) => {
        itemDescription.classList.add('no_display');
      });

      subscription.classList.add('active');

      let targetId = subscription.getAttribute('data-target');
      if (targetId) {
        document.querySelector(`#${targetId}`).classList.remove('no_display');
        document.querySelector(`#sub-description-${targetId}`).classList.remove('no_display');
      }
    })
  });

  document.querySelectorAll('.fitXr__pickSub__item')[0].click


  openCheckoutBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      const membershipType = btn.getAttribute('data-membership-type');

      userAddToCart(membershipType);
      window.location.href = btn.getAttribute('href');
    })
  })
}
